export const START_POLLING = 'START_POLLING';
export const SUBSCRIPTION_FAILED = 'SUBSCRIPTION_FAILED';
